export const resetLogoSelector = () => ({
  type: "RESET_LOGO_SELECTOR"
});

export const setLogoSelector = logoSelector => ({
  type: "SET_LOGO_SELECTOR",
  logoSelector
});



// WEBPACK FOOTER //
// ./src/actions/actions/logo-selector.js